import React from "react";
import { Link } from "react-router-dom";
import estados from "../../services/estados";
import api from "../../services/api";
import { store } from "react-notifications-component";
import GenericUpper from "../../components/generic-upper";
import { FiliaisAddContainer } from "./styles";
import { Container } from "react-grid-system";

import TextArea from "../../components/textarea/text_area_v2";
import Input from "../../components/input/input_v2";
import Select from "../../components/select/select_v2";
import Button from "../../components/button/button_v2";

import DotsLoader from "../../components/loader";
import buscaCep from "../../services/buscaCep";
import validadorCpfCnpj from "../../services/validadorCpfCnpj";
import { th } from "date-fns/locale";
import { theme } from "../../styles/theme";
import { isTotvs, isOmie } from "../../services/globalFunctions";

import identifyErrorMenssage from "../../services/identifyErrorMenssage";
class EditFiliais extends React.Component {
    state = {
        nome_fantasia: "",
        razao_social: "",
        cnpj: "",
        telefone: "",
        cep: "",
        endereco: "",
        numero: "",
        bairro: "",
        cidade: "",
        estado: "",
        id: "",
        inscricao_estadual: "",
        file: [],
        logo: "",
        namesfiles:[],
        textfile:"ADICIONAR ANEXOS (JPG ou PNG, MAX 3MB)",
        is_matriz: "",
        telefone_emergencia: "",
        loading: false,
        previewImage: null, // adicionar este estado
        nomeFantasiaErro: false,
        nomeFantasiaErroMsg: "",
        razaoSocialErro: false,
        razaoSocialErroMsg: "",
        telefoneEmergenciaErro: false,
        telefoneEmergenciaErroMsg: "",
        cnpjErro: false,
        cnpjErroMsg: "",
        cnpjValido: false,
        telefoneErro: false,
        telefoneErroMsg: "",
        cepErro: false,
        cepErroMsg: "",
        enderecoErro: false,
        enderecoErroMsg: "",
        bairroErro: false,
        bairroErroMsg: "",
        numeroErro: false,
        numeroErroMsg: "",
        cidadeErro: false,
        cidadeErroMsg: "",
        estadoErro: false,
        estadoErroMsg: "",
        inscricaoEstadualErro: false,
        inscricaoEstadualErroMsg: "",
    };

    componentDidMount() {
        this.getFiliais();
    }

    // O CEP vem da API apenas com números. Aplica a mesma máscara do Input
    // (name="cep") para o campo já abrir formatado.
    formatarCep = (cep) => {
        if (cep === null || cep === undefined) return cep;

        const numeros = String(cep).replace(/\D/g, "").slice(0, 8);

        if (numeros.length <= 5) {
            return numeros.replace(/^(\d{2})(\d)/, "$1.$2");
        }

        return numeros.replace(/^(\d{2})(\d{3})(\d)/, "$1.$2-$3");
    };

    getFiliais = async () => {
        try {
            const id = this.props.match.params.id;
            this.setState({ id });
    
            const response = await api.get(`/filiais/${id}`);
            const filiais = response.data.data;
    
            const {
                nome_fantasia,
                razao_social,
                cnpj,
                telefone,
                cep,
                endereco,
                numero,
                bairro,
                cidade,
                estado,
                logo,
                is_matriz,
                imageEmpresa = filiais.logo,
                telefone_emergencia,
                inscricao_estadual
            } = filiais;
    
            this.setState({
                nome_fantasia,
                razao_social,
                cnpj,
                telefone,
                cep: this.formatarCep(cep),
                endereco,
                numero,
                bairro,
                cidade,
                estado,
                imageEmpresa,
                is_matriz,
                logo,
                inscricao_estadual,
                telefone_emergencia
            }, () => {
                // Valida o documento já cadastrado sem notificar, apenas para
                // liberar/bloquear o botão de salvar ao abrir a tela.
                this.validarDocumento({ notificar: false });
            });
            
        } catch (error) {
            store.addNotification({
                title: "Aviso!",
                message: identifyErrorMenssage(error),
                type: "warning",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    };

    fetchCep = async () => {
        const { cep } = this.state;

        const mensagemCep = this.validarCampo("cep", cep);
        if (mensagemCep) {
            this.setErroCampo("cep", mensagemCep);
            return;
        }

        this.setErroCampo("cep", "");

        try {
            const responseCep = await buscaCep(cep);
            const { logradouro, localidade, bairro, uf } = responseCep;

            this.setState({
                endereco: logradouro,
                cidade: localidade,
                bairro: bairro,
                estado: uf
            });

        } catch (err) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(err),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    };

    // Mapa de cada campo para as chaves de erro correspondentes no state.
    camposErroMap = {
        nome_fantasia: ["nomeFantasiaErro", "nomeFantasiaErroMsg"],
        razao_social: ["razaoSocialErro", "razaoSocialErroMsg"],
        telefone_emergencia: ["telefoneEmergenciaErro", "telefoneEmergenciaErroMsg"],
        cnpj: ["cnpjErro", "cnpjErroMsg"],
        telefone: ["telefoneErro", "telefoneErroMsg"],
        cep: ["cepErro", "cepErroMsg"],
        endereco: ["enderecoErro", "enderecoErroMsg"],
        bairro: ["bairroErro", "bairroErroMsg"],
        numero: ["numeroErro", "numeroErroMsg"],
        cidade: ["cidadeErro", "cidadeErroMsg"],
        estado: ["estadoErro", "estadoErroMsg"],
        inscricao_estadual: ["inscricaoEstadualErro", "inscricaoEstadualErroMsg"],
    };

    // Regras de preenchimento de cada campo obrigatório. Retorna a mensagem
    // de erro ou "" quando o valor está correto.
    validarCampo = (campo, valor) => {
        const texto = valor === null || valor === undefined ? "" : String(valor).trim();
        const numeros = texto.replace(/\D/g, "");

        if (texto === "") {
            return "O campo não pode estar em branco!";
        }

        switch (campo) {
            case "nome_fantasia":
            case "razao_social":
                return texto.length < 3 ? "Informe ao menos 3 caracteres." : "";

            case "telefone":
                return numeros.length < 10 || numeros.length > 11
                    ? "Informe um telefone com DDD (10 ou 11 dígitos)."
                    : "";

            case "cep":
                return numeros.length !== 8 ? "Informe um CEP com 8 dígitos." : "";

            // CPF/CNPJ tem validação própria no validarDocumento().
            default:
                return "";
        }
    };

    // Aplica (ou limpa) o erro de um campo no state.
    setErroCampo = (campo, mensagem) => {
        const chaves = this.camposErroMap[campo];
        if (!chaves) return;

        const [erroKey, msgKey] = chaves;
        this.setState({ [erroKey]: !!mensagem, [msgKey]: mensagem || "" });
    };

    handleBlurCampo = (campo) => () => {
        this.setErroCampo(campo, this.validarCampo(campo, this.state[campo]));
    };

    // Campos obrigatórios do formulário (os marcados com asterisco). A
    // inscrição estadual só é exigida quando o campo é exibido.
    camposObrigatorios = () => {
        const campos = [
            "nome_fantasia",
            "razao_social",
            "cnpj",
            "telefone",
            "cep",
            "endereco",
            "numero",
            "bairro",
            "cidade",
            "estado",
        ];

        if (this.state.inscricao_estadual !== null) {
            campos.push("inscricao_estadual");
        }

        return campos;
    };

    // O botão de salvar só libera quando todos os obrigatórios estão
    // preenchidos, o documento foi validado e não há nenhum erro em tela.
    // Retorna { campo: mensagem } para todos os obrigatórios preenchidos de
    // forma incorreta (ou em branco).
    camposInvalidos = () => {
        const invalidos = {};

        this.camposObrigatorios().forEach((campo) => {
            const mensagem = this.validarCampo(campo, this.state[campo]);
            if (mensagem) {
                invalidos[campo] = mensagem;
            }
        });

        return invalidos;
    };

    // Guarda executada antes de qualquer envio: marca os campos incorretos em
    // tela, revalida o documento e avisa o usuário. Retorna false para
    // interromper o salvamento.
    validarFormulario = async () => {
        const invalidos = this.camposInvalidos();

        Object.entries(invalidos).forEach(([campo, mensagem]) => {
            this.setErroCampo(campo, mensagem);
        });

        const documentoValido = await this.validarDocumento();

        if (Object.keys(invalidos).length === 0 && documentoValido) {
            return true;
        }

        if (Object.keys(invalidos).length > 0) {
            store.addNotification({
                title: "Atenção!",
                message: "Preencha corretamente todos os campos obrigatórios antes de salvar.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }

        return false;
    };

    podeSalvar = () => {
        const semCamposInvalidos = Object.keys(this.camposInvalidos()).length === 0;

        return semCamposInvalidos && this.state.cnpjValido === true && !this.possuiErrosNoFormulario();
    };

    possuiErrosNoFormulario = () => {
        const {
            nomeFantasiaErro,
            razaoSocialErro,
            telefoneEmergenciaErro,
            cnpjErro,
            telefoneErro,
            cepErro,
            enderecoErro,
            bairroErro,
            numeroErro,
            cidadeErro,
            estadoErro,
            inscricaoEstadualErro,
        } = this.state;

        return [
            nomeFantasiaErro,
            razaoSocialErro,
            telefoneEmergenciaErro,
            cnpjErro,
            telefoneErro,
            cepErro,
            enderecoErro,
            bairroErro,
            numeroErro,
            cidadeErro,
            estadoErro,
            inscricaoEstadualErro,
        ].some((erro) => erro === true);
    };

    notificarDocumentoInvalido = (erro) => {
        store.addNotification({
            title: "Documento inválido!",
            message: `${erro || "CPF/CNPJ inválido"}. Confira os números digitados e informe um CPF (11 dígitos) ou um CNPJ (14 dígitos) válido para continuar.`,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
                duration: 4000,
                onScreen: true
            }
        });
    };

    validarDocumento = async ({ notificar = true } = {}) => {
        const { cnpj } = this.state;

        if (!cnpj || !cnpj.toString().trim()) {
            this.setState({ cnpjValido: false });
            return false;
        }

        const resultado = await validadorCpfCnpj(cnpj);

        if (!resultado.valido) {
            this.setState({
                cnpjErro: true,
                cnpjErroMsg: resultado.erro || "Informe um CPF ou CNPJ válido.",
                cnpjValido: false,
            });
            if (notificar) {
                this.notificarDocumentoInvalido(resultado.erro);
            }
            return false;
        }

        this.setState({ cnpjErro: false, cnpjErroMsg: "", cnpjValido: true });
        return true;
    };

    handleBlurCnpj = () => this.validarDocumento();

    resetRequiredFieldErrors = () => {
        this.setState({
            nomeFantasiaErro: false,
            nomeFantasiaErroMsg: "",
            razaoSocialErro: false,
            razaoSocialErroMsg: "",
            telefoneEmergenciaErro: false,
            telefoneEmergenciaErroMsg: "",
            cnpjErro: false,
            cnpjErroMsg: "",
            telefoneErro: false,
            telefoneErroMsg: "",
            cepErro: false,
            cepErroMsg: "",
            enderecoErro: false,
            enderecoErroMsg: "",
            bairroErro: false,
            bairroErroMsg: "",
            numeroErro: false,
            numeroErroMsg: "",
            cidadeErro: false,
            cidadeErroMsg: "",
            estadoErro: false,
            estadoErroMsg: "",
            inscricaoEstadualErro: false,
            inscricaoEstadualErroMsg: "",
        });
    };

    applyApiRequiredFieldErrors = (err) => {
        const responseData = err?.response?.data;
        const messages = [];

        if (Array.isArray(responseData)) messages.push(...responseData);
        if (Array.isArray(responseData?.message)) messages.push(...responseData.message);
        if (Array.isArray(responseData?.errors)) messages.push(...responseData.errors);
        if (Array.isArray(responseData?.data?.message)) messages.push(...responseData.data.message);

        const updates = {};
        const map = this.camposErroMap;

        messages.forEach((message) => {
            const text = String(message || "").toLowerCase();
            Object.entries(map).forEach(([field, [erroKey, msgKey]]) => {
                if (text.includes(`${field} should not be empty`)) {
                    updates[erroKey] = true;
                    updates[msgKey] = "O campo não pode estar em branco!";
                }
            });
        });

        if (Object.keys(updates).length > 0) {
            this.setState(updates);
            return true;
        }

        return false;
    };

    editPost = async () => {

        const formularioValido = await this.validarFormulario();
        if (!formularioValido) return;

        const { cnpj } = this.state;

        this.setState({ loading: true });

        const {
            nome_fantasia,
            razao_social,
            telefone_emergencia,
            telefone,
            cep,
            endereco,
            numero,
            bairro,
            cidade,
            estado,
            id,
            inscricao_estadual
        } = this.state;

        const payload = {
            nome_fantasia,
            razao_social,
            telefone_emergencia,
            cnpj,
            telefone,
            cep,
            endereco,
            numero,
            bairro,
            cidade,
            estado,
            is_matriz: 0,
            inscricao_estadual
        };

        try {
            const response = await api.put(`/filiais/${id}`, payload);

            if (response.status === 200) {
                this.setState({ loading: false });

                this.props.history.push("/filiais");
                store.addNotification({
                    title: "Sucesso!",
                    message: "A filial foi editada corretamente.",
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });

            }
        } catch (err) {
            this.setState({ loading: false });
            
            if ((err.response && err.response.status === 413) || (err.message === "Network Error" && err.toString().includes('413'))) {
                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(err, "ERRO-665 Houve um problema para salvar a imagem. Tente enviá-la em uma dimensão menor - Tente novamente, se o erro persistir acione o suporte."),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            } else {
                this.resetRequiredFieldErrors();
                this.applyApiRequiredFieldErrors(err);

                store.addNotification({
                    title: "Erro!",
                    message: "Verifique os campos em vermelho",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }
        }
    };

    handlePostMatriz = async () => {

        const formularioValido = await this.validarFormulario();
        if (!formularioValido) return;

        const {
            nome_fantasia,
            razao_social,
            cnpj,
            telefone,
            telefone_emergencia,
            cep,
            endereco,
            cidade,
            bairro,
            numero,
            estado,
            file,
            inscricao_estadual
        } = this.state;

        const payload = {
            nome_fantasia,
            razao_social,
            cnpj,
            telefone,
            telefone_emergencia,
            logo: file.length > 0 ? file : "",
            cep,
            endereco,
            bairro,
            numero,
            cidade,
            estado,
            is_matriz: 1,
            inscricao_estadual
        };

        try {
            this.setState({loading: true});
            const response = await api.put(`/filiais/${this.state.id}`, payload);

            if (response.status === 200) {
                window.location.reload();

                store.addNotification({
                    title: "Sucesso!",
                    message: "A empresa foi salva corretamente.",
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });

                window.location.reload();
            }
            this.setState({loading: false});
        } catch (err) {
            this.setState({loading: false});
            
            if ((err.response && err.response.status === 413) || (err.message === "Network Error")) {
                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(err, "ERRO-666 Houve um problema para salvar a imagem. Tente enviá-la em uma dimensão menor - Tente novamente, se o erro persistir acione o suporte."),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            } else {
                this.resetRequiredFieldErrors();
                this.applyApiRequiredFieldErrors(err);

                store.addNotification({
                    title: "Erro!",
                    message: "Verifique os campos vazios",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }
            
            this.setState({loading: false});
        }
    };

    onKeyDownFormater = (e, campo) => {
        if(e.keyCode === 8) {
            const value = document.getElementsByName(campo);
            return value[0].value;
        }
    }

    onChange = async (e) => {
        if(e.target.files && e.target.files[0]) {
            const file = e.target.files[0];

            // Validação do tipo de arquivo
            if(file.type !== "image/png" && file.type !== "image/jpeg"){
                store.addNotification({
                    title: "Erro!",
                    message: "O arquivo selecionado não possui a extensão correta",
                    type: "warning",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
                e.target.value = ''; // Limpa o input
                return;
            }

            // Validação do tamanho do arquivo (3MB = 3 * 1024 * 1024 bytes)
            if (file.size > 3 * 1024 * 1024) {
                store.addNotification({
                    title: "Erro!",
                    message: "O arquivo deve ter no máximo 3MB",
                    type: "warning",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
                e.target.value = ''; // Limpa o input
                return;
            }

            // Validação das dimensões da imagem
            const img = new Image();
            const reader = new FileReader();
            
            reader.onload = (event) => {
                img.src = event.target.result;
                
                img.onload = () => {
                    
                    // Se passou por todas as validações, atualiza o estado
                    this.setState({ 
                        file: event.target.result,
                        imageEmpresa: null,
                        previewImage: event.target.result,
                        textfile: "Imagem selecionada com sucesso!"
                    });
                    
                    if (!this.state.namesfiles.includes(file.name)) {
                        this.state.namesfiles.push(file.name);
                    }
                };
            };
            
            reader.readAsDataURL(file);
        }
    }

    back = () => {
        window.location = '/filiais';
    }
    
    render() {
        const {
            nome_fantasia,
            razao_social,
            cnpj,
            telefone,
            cep,
            endereco,
            numero,
            bairro,
            cidade,
            estado,
            is_matriz,
            telefone_emergencia,
            inscricao_estadual,
            nomeFantasiaErro,
            nomeFantasiaErroMsg,
            razaoSocialErro,
            razaoSocialErroMsg,
            telefoneEmergenciaErro,
            telefoneEmergenciaErroMsg,
            cnpjErro,
            cnpjErroMsg,
            telefoneErro,
            telefoneErroMsg,
            cepErro,
            cepErroMsg,
            enderecoErro,
            enderecoErroMsg,
            bairroErro,
            bairroErroMsg,
            numeroErro,
            numeroErroMsg,
            cidadeErro,
            cidadeErroMsg,
            estadoErro,
            estadoErroMsg,
            inscricaoEstadualErro,
            inscricaoEstadualErroMsg,
        } = this.state;

        if( is_matriz == 0 ){

            return (
                <>
                    <GenericUpper
                        title="Edite sua empresa"
                        subtitle="Edite esta empresa"
                    ></GenericUpper>

                    <FiliaisAddContainer>
                        <Container>
                                <form>
                                    <Input
                                        name="nome_fantasia"
                                        type="text"
                                        label="Nome Fantasia"
                                        labelWithAsterisk
                                        id="id_nome_fantasia"
                                        rows="1"
                                        cols="22"
                                        value={nome_fantasia}
                                        onChange={e => this.setState({ nome_fantasia: e })}
                                        onBlur={this.handleBlurCampo('nome_fantasia')}
                                        erro={nomeFantasiaErro}
                                        messageErro={nomeFantasiaErroMsg}
                                        disabled={isTotvs() && !isOmie()}
                                    />

                                    <Input
                                        name="razao_social"
                                        type="text"
                                        label="Razão Social"
                                        labelWithAsterisk
                                        id="id_razao_social"
                                        rows="1"
                                        cols="22"
                                        value={razao_social}
                                        onChange={e => this.setState({ razao_social: e })}
                                        onBlur={this.handleBlurCampo('razao_social')}
                                        erro={razaoSocialErro}
                                        messageErro={razaoSocialErroMsg}
                                        disabled={isTotvs() && !isOmie()}
                                    />

                                    <Input
                                        name="cpfcnpj"
                                        type="text"
                                        label="CPF/CNPJ"
                                        labelWithAsterisk
                                        id="id_cnpj"
                                        value={cnpj}
                                        onChange={e => this.setState({ cnpj: e, cnpjValido: false })}
                                        onBlur={this.handleBlurCnpj}
                                        erro={cnpjErro}
                                        messageErro={cnpjErroMsg}
                                        disabled={isTotvs() && !isOmie()}
                                    />

                                    <Input
                                        name="telefone"
                                        type="text"
                                        label="Telefone"
                                        labelWithAsterisk
                                        id="id_telefone"
                                        value={telefone}
                                        onChange={e => this.setState({ telefone: e })}
                                        onBlur={this.handleBlurCampo('telefone')}
                                        erro={telefoneErro}
                                        messageErro={telefoneErroMsg}
                                        disabled={isTotvs() && !isOmie()}
                                    />

                                    <Input
                                        name="cep"
                                        type="text"
                                        label="CEP"
                                        labelWithAsterisk
                                        id="id_cep"
                                        value={cep}
                                        onChange={e => this.setState({ cep: e })}
                                        onBlur={this.fetchCep}
                                        erro={cepErro}
                                        messageErro={cepErroMsg}
                                        disabled={isTotvs() && !isOmie()}
                                    />
                                    
                                    {
                                        inscricao_estadual !== null && (
                                            <Input
                                                name="Inscrição Estadual"
                                                type="text"
                                                label="Inscrição Estadual"
                                                labelWithAsterisk
                                                id="inscricao_estadual"
                                                value={inscricao_estadual}
                                                onChange={e => this.setState({ inscricao_estadual: e })}
                                                onBlur={this.handleBlurCampo('inscricao_estadual')}
                                                erro={inscricaoEstadualErro}
                                                messageErro={inscricaoEstadualErroMsg}
                                                disabled={isTotvs() && !isOmie()}
                                            />
                                        )
                                    }

                                    <Input
                                        name="endereco"
                                        type="text"
                                        label="Endereço"
                                        labelWithAsterisk
                                        id="id_endereco"
                                        value={endereco}
                                        onChange={e => this.setState({ endereco: e })}
                                        onBlur={this.handleBlurCampo('endereco')}
                                        erro={enderecoErro}
                                        messageErro={enderecoErroMsg}
                                        disabled={isTotvs() && !isOmie()}
                                    />

                                    <Input
                                        name="numero"
                                        label="Número"
                                        labelWithAsterisk
                                        id="id_numero"
                                        value={numero}
                                        onChange={e => this.setState({ numero: e })}
                                        onBlur={this.handleBlurCampo('numero')}
                                        erro={numeroErro}
                                        messageErro={numeroErroMsg}
                                        disabled={isTotvs() && !isOmie()}
                                    />

                                    <Input
                                        name="bairro"
                                        type="text"
                                        label="Bairro"
                                        labelWithAsterisk
                                        id="id_bairro"
                                        value={bairro}
                                        onChange={e => this.setState({ bairro: e })}
                                        onBlur={this.handleBlurCampo('bairro')}
                                        erro={bairroErro}
                                        messageErro={bairroErroMsg}
                                        disabled={isTotvs() && !isOmie()}
                                    />

                                    <Input
                                        name="cidade"
                                        type="text"
                                        label="Cidade"
                                        labelWithAsterisk
                                        id="id_cidade"
                                        value={cidade}
                                        onChange={e => this.setState({ cidade: e })}
                                        onBlur={this.handleBlurCampo('cidade')}
                                        erro={cidadeErro}
                                        messageErro={cidadeErroMsg}
                                        disabled={isTotvs() && !isOmie()}
                                    />

                                    <Select
                                        name="estado"
                                        className="select"
                                        label="Estado"
                                        labelWithAsterisk
                                        id="id_estado"
                                        value={estado}
                                        onChange={state => this.setState({ estado: state.value })}
                                        options={estados}
                                        estado={true}
                                        erro={estadoErro}
                                        messageErro={estadoErroMsg}
                                        disabled={isTotvs() && !isOmie()}
                                    />

                                    <div 
                                        className="button-finish" 
                                        style={{ 
                                            width: '100%', 
                                            display: 'flex', 
                                            flexDirection: 'row', 
                                            justifyContent: 'space-evenly',
                                            alignItems: 'center', 
                                            marginTop: '40px',
                                        }}
                                    >
                                        <Button 
                                            width='45%'
                                            height='50px'
                                            value='VOLTAR'
                                            outline={true}
                                            color={theme.colors.gray.Cinza_2}
                                            disabled={false}
                                            onClick={() => this.back()}
                                            loading={false}
                                        />

                                        <Button 
                                            width='45%'
                                            height='50px'
                                            value='SALVAR'
                                            disabled={!this.podeSalvar()}
                                            tooltip={true}
                                            tooltipMsg='Preencha corretamente todos os campos obrigatórios para salvar.'
                                            onClick={() => this.editPost()}
                                            loading={this.state.loading}
                                        />
                                    </div>
                                </form>
            
                            </Container>
                </FiliaisAddContainer>
                </>
            );  
        }else {
            return (<>
                 <GenericUpper
                        title="Edite sua empresa"
                        subtitle="Edite esta empresa"
                    ></GenericUpper>
                    <FiliaisAddContainer>
                        <Container>
                          <form>
                                <Input
                                    name="nome_fantasia"
                                    type="text"
                                    label="Nome Fantasia"
                                    labelWithAsterisk
                                    id="id_nome_fantasia"
                                    rows="1"
                                    cols="22"
                                    value={nome_fantasia}
                                    onChange={e => this.setState({ nome_fantasia: e})}
                                    onBlur={this.handleBlurCampo('nome_fantasia')}
                                    erro={nomeFantasiaErro}
                                    messageErro={nomeFantasiaErroMsg}
                                    disabled={isTotvs() && !isOmie()}
                                />

                                <Input
                                    name="razao_social"
                                    type="text"
                                    label="Razão Social"
                                    labelWithAsterisk
                                    id="id_razao_social"
                                    rows="1"
                                    cols="22"
                                    value={razao_social}
                                    onChange={e => this.setState({ razao_social: e })}
                                    onBlur={this.handleBlurCampo('razao_social')}
                                    erro={razaoSocialErro}
                                    messageErro={razaoSocialErroMsg}
                                    disabled={isTotvs() && !isOmie()}
                                />

                                <Input
                                    name="cpfcnpj"
                                    type="text"
                                    label="CPF/CNPJ"
                                    labelWithAsterisk
                                    id="id_cnpj"
                                    value={cnpj}
                                    onChange={e => this.setState({ cnpj: e, cnpjValido: false })}
                                    onBlur={this.handleBlurCnpj}
                                    erro={cnpjErro}
                                    messageErro={cnpjErroMsg}
                                    disabled={isTotvs() && !isOmie()}
                                />

                                <Input
                                    name="telefone"
                                    type="text"
                                    label="Telefone"
                                    labelWithAsterisk
                                    id="id_telefone"
                                    value={telefone}
                                    onChange={e => this.setState({ telefone: e })}
                                    onBlur={this.handleBlurCampo('telefone')}
                                    erro={telefoneErro}
                                    messageErro={telefoneErroMsg}
                                    disabled={isTotvs() && !isOmie()}
                                />


                                <Input
                                    name="telefone_emergencia"
                                    type="text"
                                    label="Telefone de emergência"
                                    id="id_telefone_emergencia"
                                    value={telefone_emergencia}
                                    onChange={e => this.setState({ telefone_emergencia: e })}
                                    erro={telefoneEmergenciaErro}
                                    messageErro={telefoneEmergenciaErroMsg}
                                    disabled={isTotvs() && !isOmie()}
                                />


                                <Input
                                    name="cep"
                                    type="text"
                                    label="CEP"
                                    labelWithAsterisk
                                    id="id_cep"
                                    value={cep}
                                    onChange={e => this.setState({ cep: e })}
                                    onBlur={this.fetchCep}
                                    erro={cepErro}
                                    messageErro={cepErroMsg}
                                    disabled={isTotvs() && !isOmie()}
                                />

                                { 
                                    inscricao_estadual !== null && (
                                        <Input
                                            name="Inscrição Estadual"
                                            type="text"
                                            label="Inscrição Estadual"
                                            labelWithAsterisk
                                            id="inscricao_estadual"
                                            value={inscricao_estadual}
                                            onChange={e => this.setState({ inscricao_estadual: e })}
                                            onBlur={this.handleBlurCampo('inscricao_estadual')}
                                            erro={inscricaoEstadualErro}
                                            messageErro={inscricaoEstadualErroMsg}
                                            disabled={isTotvs() && !isOmie()}
                                        />
                                    )
                                }

                                <Input
                                    name="endereco"
                                    type="text"
                                    label="Endereço"
                                    labelWithAsterisk
                                    id="id_endereco"
                                    value={endereco}
                                    onChange={e => this.setState({ endereco: e })}
                                    onBlur={this.handleBlurCampo('endereco')}
                                    erro={enderecoErro}
                                    messageErro={enderecoErroMsg}
                                    disabled={isTotvs() && !isOmie()}
                                />

                                <Input
                                    name="numero"
                                    label="Número"
                                    labelWithAsterisk
                                    id="id_numero"
                                    value={numero}
                                    onChange={e => this.setState({ numero: e })}
                                    onBlur={this.handleBlurCampo('numero')}
                                    erro={numeroErro}
                                    messageErro={numeroErroMsg}
                                    disabled={isTotvs() && !isOmie()}
                                />

                                <Input
                                    name="bairro"
                                    type="text"
                                    label="Bairro"
                                    labelWithAsterisk
                                    id="id_bairro"
                                    value={bairro}
                                    onChange={e => this.setState({ bairro: e })}
                                    onBlur={this.handleBlurCampo('bairro')}
                                    erro={bairroErro}
                                    messageErro={bairroErroMsg}
                                    disabled={isTotvs() && !isOmie()}
                                />

                                <Input
                                    name="cidade"
                                    type="text"
                                    label="Cidade"
                                    labelWithAsterisk
                                    id="id_cidade"
                                    value={cidade}
                                    onChange={e => this.setState({ cidade: e })}
                                    onBlur={this.handleBlurCampo('cidade')}
                                    erro={cidadeErro}
                                    messageErro={cidadeErroMsg}
                                    disabled={isTotvs() && !isOmie()}
                                />

                                <Select
                                    name="estado"
                                    className="select"
                                    label="Estado"
                                    labelWithAsterisk
                                    id="id_estado"
                                    value={estado}
                                    onChange={state => this.setState({ estado: state.value })}
                                    options={estados}
                                    estado={true}
                                    marginBottom="50px"
                                    erro={estadoErro}
                                    messageErro={estadoErroMsg}
                                    disabled={isTotvs() && !isOmie()}
                                />

                                <label style={{marginTop: '0px', marginBottom: '2px', marginLeft: '-193px', fontSize: '12px', fontWeight: '700', color: '#8192a2'}}>Adicionar Logomarca </label>
                                
                                {/* <div class='input-wrapper'>
                                    <label for='id_input-file' multiple>
                                        {this.state.textfile}
                                    </label>

                                    <input 
                                        style={{marginTop: '20px'}}
                                        type="file"
                                        id="id_input-file"
                                        name="file"
                                        accept="image/png, image/jpeg"
                                        multiple
                                        onChange={(e)=>this.onChange(e)}
                                    />

                                    <span id='file-name'></span>
                                    
                                </div>                                 */}



                                <div 
                                    for='id_input-file' 
                                    onClick={() => document.getElementById('id_input-file').click()}
                                    style={{
                                        width: '100%',
                                        height: (this.state.imageEmpresa || this.state.previewImage) ? 'auto' : '108px',
                                        backgroundColor: `${theme.colors.white.Branco}`,
                                        borderRadius: '1px',
                                        border: '1px dashed #8a92a2',
                                        color: '#8a92a2',
                                        padding: '12px 20px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginBottom: '40px',
                                    }}
                                >
                                    {this.state.imageEmpresa || this.state.previewImage ? (
                                         <img 
                                            src={this.state.imageEmpresa || this.state.previewImage} 
                                            alt="Logo empresa" 
                                            style={{
                                                maxWidth: "380px",
                                                maxHeight: "380px",
                                                width: 'auto',
                                                height: 'auto',
                                                objectFit: 'contain'
                                            }}
                                         />
                                    ):(
                                        <p
                                        style={{
                                            width: '100%',
                                            textAlign: 'center',
                                            fontSize: '15px',
                                        }}
                                    >
                                        {this.state.textfile}
                                    </p>
                                    )}
                                    
                                    {/* (Apenas: PDF, TXT, PNG, GIF, JPEG) */}
                                </div>
                                <input 
                                    style={{marginTop: '20px'}}
                                    type="file"
                                    id="id_input-file"
                                    name="file"
                                    accept="image/png, image/jpeg"
                                    multiple
                                    onChange={(e)=>{
                                        this.onChange(e)
                                        
                                        if (e.target.files.length > 0) {
                                            this.setState({ imageEmpresa: null })
                                        }
                                    }}
                                    disabled={isTotvs() && !isOmie()}
                                />

                                <span id='file-name'></span>

                                <div 
                                    className="button-finish" 
                                    style={{ 
                                        width: '100%', 
                                        display: 'flex', 
                                        flexDirection: 'row', 
                                        justifyContent: 'space-evenly',
                                        alignItems: 'center', 
                                        marginTop: '40px',
                                    }}
                                >
                                    <Button 
                                        width='45%'
                                        height='50px'
                                        value='VOLTAR'
                                        outline={true}
                                        color={theme.colors.gray.Cinza_2}
                                        disabled={false}
                                        onClick={() => this.back()}
                                        loading={false}
                                    />

                                    <Button 
                                        width='45%'
                                        height='50px'
                                        value='SALVAR'
                                        disabled={!this.podeSalvar()}
                                        tooltip={true}
                                        tooltipMsg='Preencha corretamente todos os campos obrigatórios para salvar.'
                                        onClick={() => this.handlePostMatriz()}
                                        loading={this.state.loading}
                                    />
                                </div>

                            </form>

                    </Container>
                </FiliaisAddContainer>
            </>);
        }
    }
};
export default  EditFiliais;
